module.exports = "//static.hsappstatic.net/LoginUI/static-1.16032/img/hubspotMobileApp2FA.png"